import { sortBy, isEqual } from 'lodash';

export const compareTwoArray = (arr1, arr2) => isEqual(sortBy(arr1), sortBy(arr2));
